import moment from 'moment'
import React, { CSSProperties, ReactNode } from 'react'
import { images } from '../../../../images'
import { IAvailability, IStop } from '../../../../models'
import { LiteralsService } from '../../../../services'
import theme from '../../../../theme'
import StyledDiv from './styles'
import { TagComponent } from '../../../../components/ServiceCheckbox/TagComponent'
import { StopMarker, StopsRouteDots } from '../../../../components'

interface IProps {
  routeOption: IAvailability
  onClick: (ro: IAvailability) => void
  isLast: boolean
  pickedOriginBusStop?: IStop
  pickedDestinationBusStop?: IStop
  selected: boolean
  isSingleStop?: boolean
}

export const Card: React.FC<IProps> = ({
  routeOption, onClick, isLast, pickedOriginBusStop, pickedDestinationBusStop, selected, isSingleStop
}) => {
  const cardStyles = (): CSSProperties => {
    let styles = {}
    if (selected) styles = {
      border: `2px solid ${theme.colors.primary}` 
    }
    if (isLast) {
      styles = {
        ...styles,
        marginBottom: 24
      }
    }
    return {
      ...styles
    }
  }

  const timeText = (): string => {
    const departureTime = moment(routeOption.inStop.dateTime).format('HH:mm')
    const arrivalTime = moment(routeOption.outStops[0].dateTime).format('HH:mm')

    // eslint-disable-next-line max-len
    return `${ LiteralsService.get('departure', true) } ${ departureTime } - ${ LiteralsService.get('arrival', true) } ${ arrivalTime }`
  }

  const isBeginingStopUnavailable = (): boolean => {
    const isBeginingStopDisabled = pickedOriginBusStop
      ? routeOption.inStop.name !== pickedOriginBusStop.name
      : false

    return routeOption.alternative && isBeginingStopDisabled
  }

  const isDestinationStopUnavailable = (): boolean => {
    const isDestinationStopDisabled = pickedDestinationBusStop
      ? routeOption.outStops[0].name !== pickedDestinationBusStop.name
      : false

    return routeOption.alternative && isDestinationStopDisabled
  }

  const routeIcons = (): ReactNode => {
    if (isBeginingStopUnavailable()) {
      return (
        <>
          <img src={ images['pedestrian'] } alt="pedestrian" />
          <span className="dotted">...</span>
        </>
      )
    }
    if (isDestinationStopUnavailable()) {
      return (
        <>
          <span className="dotted">...</span>
          <img src={ images['pedestrian'] } alt="pedestrian" />
        </>
      )
    }
    return (
      <>
        <img src={ images['pedestrian'] } alt="pedestrian" />
        <span className="dotted">...</span>
      </>
    )
  }

  const getStopTextWidth = () => {
    if (isSingleStop) return '100%'
    return isBeginingStopUnavailable() && !isDestinationStopUnavailable() ? '30%': '35%'
  }

  return (
    <StyledDiv className="card" onClick={ () => onClick(routeOption) } style={ cardStyles() }>
      <div className="details">
        <div className="row">
          <TagComponent tag={ routeOption.serviceInfo.tag } color={ routeOption.serviceInfo.color } clickable={false} />
          <span className='service-name'>{ routeOption.serviceInfo.name }</span>
        </div>
        <div className="row">
          { isBeginingStopUnavailable() && routeIcons() }
          <img src={ images['bus'] }  alt="bus" />
          {
            (!isSingleStop || (isSingleStop && pickedOriginBusStop)) &&
            <div className="stop-name" style={{ maxWidth: getStopTextWidth() }}>
              {
                isSingleStop && 
                <StopMarker color={ theme.colors.accent } />
              }
              <span>
                { routeOption.inStop.name }
              </span>
            </div>
          }
          {
            !isSingleStop &&
            <div className="stops-dots">
              <StopsRouteDots 
                colorStart={ theme.colors.accent }
                colorEnd={ theme.colors.greenRadio }
                horizontal={ true }
              />
            </div>
          }
          {
            routeOption.outStops.length > 0 && 
            (!isSingleStop || (isSingleStop && pickedDestinationBusStop)) &&
            <div className="stop-name" style={{ maxWidth: getStopTextWidth() }}>
              {
                isSingleStop && 
                <StopMarker color={ theme.colors.greenRadio } />
              }
              <span>
                { routeOption.outStops[0].name }
              </span>
            </div>
          }
          { isDestinationStopUnavailable() && routeIcons() }
        </div>
        <div className="row" style={{ marginTop: '8px' }}>
          <span>{ timeText() }</span>
        </div>
      </div>
    </StyledDiv>
  )
}
